import type { IOrder } from '@rendora/common/entities/order';
import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import TransferInterceptModal from './TransferIntercept.vue';

const modalSymbol = Symbol('transfer-intercept-modal');

export const useTransferIntercept = (options: { order: IOrder; onCancel?: () => void }) => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  ModalFactory.create(
    {
      width: 420,
      showHeader: true,
      showCloseButton: true,
      title: $t('dai-zhi-fu-dui-gong-ding-dan-ti-xing'),
      content: <TransferInterceptModal order={options.order} />,
    },
    modalSymbol,
  );
};
